import { useStore } from 'effector-react'
import {
  $accountForm,
  $errorClientLeverageLimit,
  updateLeverageLimit,
} from './model'

export const useClientLeverageLimit = () => {
  const accountForm = useStore($accountForm)
  const loading = useStore(updateLeverageLimit.pending)
  const clientLeverageLimitError = useStore($errorClientLeverageLimit)

  return { accountForm, loading, clientLeverageLimitError }
}
